import type { CustomsOverrideClearedBySplit } from '@/infrastructure/FulfillmentAdminClient';
import { kstTimestamp } from '@/utils/fulfillmentTime';

interface CustomsSplitClearingNoteProps {
  lineNo: number;
  /** Undefined is an older API response and is treated like null. */
  notice: CustomsOverrideClearedBySplit | null | undefined;
}

/** A split discards the source override on every part; the old amount is not apportioned. */
export function CustomsSplitClearingNote({ lineNo, notice }: CustomsSplitClearingNoteProps) {
  if (!notice) {
    return null;
  }
  return (
    <div
      className="small text-warning mt-1"
      role="note"
      aria-label={`Customs override cleared by split for line ${lineNo}`}
    >
      Customs override USD {notice.previousValue.toFixed(2)} was cleared by a line split on{' '}
      {kstTimestamp(notice.clearedAt)}; re-enter if needed.
    </div>
  );
}
